import apiService from './api-service'

const contractsService = {}

/**
 * Retrieve a contracts by it's id
 * @param  array params (optional)
 * @return contracts
 */
contractsService.list = function (params) {
  return apiService.get(`/contract`, { params }).then(res => res.data)
}

/**
 * Retrieve a contracts belongs to investor by it's id
 * @param  array params (optional)
 * @return contracts
 */
contractsService.fromInvestor = function (id, params) {
  return apiService.get(`/contracts_investor/${id}`, { params }).then(res => res.data)
}

/**
 * Retrieve a contract file url by it's id
 * @param  array params (optional)
 * @return contracts
 */
contractsService.getFile = function (id, params) {
  return apiService.get(`/file-contract/${id}`, { params }).then(res => res.data)
}

/**
 * Retrieve a contract file url by it's id
 * @param  array params (optional)
 * @return contracts
 */
contractsService.getFileUrl = function (id, params) {
  return apiService.get(`/contract-document/${id}`, { params }).then(res => res.data)
}

/**
 * Retrieve a contracts by it's id
 * @param  int id
 * @param  array params (optional)
 * @return contracts
 */
contractsService.getById = function (id, params) {
  return apiService.get(`/contract/${id}`, { params }).then(res => res.data)
}

/**
 * Update a contracts by it's id
 * @param  int id
 * @param  array params (optional)
 * @return contracts
 */
contractsService.updateById = function (id, body) {
  return apiService.post(`/contract/${id}`, body).then(res => res.data)
}

/**
 * Create a contracts by it's id
 * @param  objet body
 * @return contracts
 */
contractsService.post = function (body) {
  return apiService.post(`/contract`, body).then(res => res.data)
}

/**
 * Get a beneficiary by it's id
 * @param  objet params
 * @return contract
 */
contractsService.getBeneficiary = function (id, params) {
  return apiService.get(`/beneficiary/${id}`, { params }).then(res => res.data)
}

/**
 * Update a beneficiary by it's id
 * @param  objet body
 * @return contract
 */
contractsService.updateBeneficiary = function (id, body) {
  return apiService.post(`/beneficiary/${id}`, body).then(res => res.data)
}

/**
 * Create a beneficiary by it's id
 * @param  objet body
 * @return contract
 */
contractsService.postBeneficiary = function (id, body) {
  return apiService.post(`/contract/${id}/beneficiary`, body).then(res => res.data)
}

/**
 * Get Contract Types
 * @param  objet body
 * @return list
 */
contractsService.getTypes = function () {
  return apiService.get(`/contract-types`).then(res => res.data)
}

/**
 * Get Frequencies of Monthly Cut
 * @param  objet body
 * @return list
 */
contractsService.getFrequencies = function () {
  return apiService.get(`/frequencies`).then(res => res.data)
}

/**
 * Get Payment Method of Monthly Cut
 * @param  objet body
 * @return list
 */
contractsService.getPaymentMethods = function () {
  return apiService.get(`/payment-methods`).then(res => res.data)
}

export default contractsService



// WEBPACK FOOTER //
// ./src/services/contracts.js